export interface MailboxUserAlias {
  id: number;
  alias: string;
}

export interface MailboxUserForward {
  id: number;
  email: string;
}

export interface MailboxUserQuota {
  id: number;
  blockSoft: number;
  blockHard: number;
  used: number;
}

export interface MailboxUserLog {
  id: number;
  log: string;
}

export enum MailboxStatus {
  CREATING,
  CREATED,
  UPDATING,
  ERROR,
  ACTIVE,
  DISABLED,
}

export enum MailboxUserStatus {
  CREATING,
  CREATED,
  UPDATING,
  ERROR,
}

export interface MailboxUser {
  id: number;
  address: string;
  username: string;
  password: string;
  realName: string;
  directory: string;
  aliases: MailboxUserAlias[];
  forwards: MailboxUserForward[];
  quota: MailboxUserQuota;
  logs: MailboxUserLog[];
  status: MailboxUserStatus;
}

export interface Mailbox {
  id: number;
  accountUser: string;
  websiteId: number;
  server: string;
  status: MailboxStatus;
  users: MailboxUser[];
}

export interface MailboxUserCreate {
  mailboxId: number;
  systemUserId: number;
  address: string;
  password: string;
  realName: string;
  aliases: string[];
  forwards: string[];
  quota?: MailboxQuotaUpdate;
  localDelivery: boolean;
}

export interface MailboxCreate {
  systemUserId: number;
  websiteId: number;
  server: string;
}

export interface MailboxQuotaUpdate {
  blockSoft: number;
  blockHard: number;
}

export interface MailboxUserUpdate {
  aliases: string[];
  forwards: string[];
  quota?: MailboxQuotaUpdate;
  realName: string;
  password?: string;
  localDelivery: boolean;
}

// For BFF
export interface User {
  id: number;
  address: string;
  username: string;
  realName: string;
  directory: string;
  blockHard: number;
  blockUsed: number;
  aliases: string[];
  forwards: string[];
  status: string;
}

export enum WebsiteMailboxStatus {
  CREATING = 'CREATING',
  CREATED = 'CREATED',
  UPDATING = 'UPDATING',
  ERROR = 'ERROR',
  ACTIVE = 'ACTIVE',
  DISABLED = 'DISABLED',
}

export interface WebsiteMailbox {
  id: number;
  users: User[];
  status: WebsiteMailboxStatus;
}

export interface MailboxData {
  websiteId: number;
  mailbox: WebsiteMailbox;
}

export interface MailboxUsersData {
  totalCount: number;
  take?: number;
  skip?: number;
  users: User[];
}
